import React from 'react';
import { Route, Routes } from 'react-router';
import { Navigate } from 'react-router-dom';
import { AppConfig } from '../AppConfig';
import { DashboardAppConfig } from '../pages/Dashboard/DashboardAppConfig';
import { TestPageDev1 } from '../pages/DevPages/TestPageDev1';
import { TestPageDev2 } from '../pages/DevPages/TestPageDev2';

const PagesRoutes = () => {
  const PageRoutes = AppConfig.pages.map((page, index) => {
    return (
      <Route path={page.url} element={page.component} key={index} />
    );
  });

  const HomeSubPagesRoutes = AppConfig.homeSubPages.map((homeSubPage, index) => {
    return (
      <Route path={homeSubPage.url} element={homeSubPage.component} key={index} />
    );
  });

  const DashboardPageRoutes = Object.values(DashboardAppConfig.pages).map((page, index) => {
    return (
      <Route path={page.url} element={page.component} key={index} />
    );
  });

  return (
    <>
      <Routes>
        {PageRoutes}
        {HomeSubPagesRoutes}
        {DashboardPageRoutes}
        <Route path="/dev1" element={<TestPageDev1 />} />
        <Route path="/dev2" element={<TestPageDev2 />} />
        <Route path="*" element={<Navigate to={AppConfig.defaultRoute} replace={true} />} />
      </Routes>
    </>
  );
};

export { PagesRoutes };
